import axios from 'axios';
export class ApiClient {
    axiosInstance;
    constructor(baseURL) {
        this.axiosInstance = axios.create({ baseURL });
    }
    async authorize(tenantId, publicKey, subject) {
        const req = { tenantId, publicKey, subject };
        const result = await this.axiosInstance.post('/api/v1/pubsub/subscriber/authorize', req);
        const res = result.data;
        return res;
    }
    async subscribe(tenantId, publicKey) {
        const req = { tenantId, publicKey };
        const result = await this.axiosInstance.post('/api/v1/pubsub/subscriber/subscribe', req);
        const res = result.data;
        return res;
    }
    async getSubscribers(tenantId, subject) {
        const req = { tenantId, subject };
        const result = await this.axiosInstance.post('/api/v1/pubsub/subscriber', req);
        const res = result.data;
        return res;
    }
}
//# sourceMappingURL=api-client.js.map